import { RoleState, RoleStateStatus } from './types';

const initialState: RoleState = {
  isLoading: false,
  isError: false,
  error: null,
  roles: [],
};

const roleReducer = (state = initialState, action: any): RoleState => {
  switch (action.type) {
    case RoleStateStatus.GET_ROLE_REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case RoleStateStatus.GET_ROLE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        roles: action.payload,
        isError: false,
      };
    case RoleStateStatus.GET_ROLE_FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default roleReducer;
